export function isRequiredValid(data) {
  return data.length > 0 || "This field is required";
}

export const rules = [isRequiredValid];
